// extracted by mini-css-extract-plugin
export var downArrow = "_a5-0";
export var label = "_a5-1";
export var treatmentCard = "_a5-3";
export var upArrow = "_a5-2";